"use client";

import { X } from "lucide-react";
import { useRouter } from "next/navigation";

interface TourSignupModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function TourSignupModal({ isOpen, onClose }: TourSignupModalProps) {
    const router = useRouter();

    if (!isOpen) return null;

    const handleSignupClick = () => {
        onClose();
        router.push("/login");
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                onClick={onClose}
            />

            {/* Modal */}
            <div className="relative bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all">
                {/* Close button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <X className="w-5 h-5" />
                </button>

                {/* Content */}
                <div className="text-center">
                    {/* Celebration emoji */}
                    <div className="text-6xl mb-4">🎉</div>

                    {/* Title */}
                    <h2 className="text-2xl font-bold text-gray-900 mb-3">
                        Congratulations!
                    </h2>

                    {/* Subtitle */}
                    <p className="text-lg text-green-600 font-semibold mb-4">
                        You've secured FREE access to the UCI Tour of Guangxi 2025!
                    </p>

                    {/* Description */}
                    <p className="text-gray-600 mb-6 leading-relaxed">
                        You're one of the first 1,000 users to claim this exclusive offer.
                        The event has finished, but catch all the replays from multiple commentators!
                    </p>

                    {/* Call to action */}
                    <button
                        onClick={handleSignupClick}
                        className="w-full bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 flex items-center justify-center space-x-2"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                        </svg>
                        <span>Sign up to finalise your seat</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
